import { parseCommunityPortfolioIdsResponse } from 'lib/webApiContracts'
import { apiGet } from '../../../lib/api'
import { queryClient } from '../../../lib/query-client'
import { insightsCoreKeys } from '../../../lib/queryKeys'
import {
  completeInsightsMeasure,
  INSIGHTS_PERFORMANCE,
  startInsightsMeasure,
} from '../../../performance/insightsPerformance'

/**
 * The directory is read by the Insights shell, Tasks, Resident Conversations,
 * and Agentic Chat. It rarely changes during a session and the old module
 * cache never refetched it, so it stays fresh for 5 minutes and every reader
 * shares one cached request per user.
 */
const COMMUNITY_PORTFOLIO_STALE_TIME_MS = 5 * 60 * 1000

const fetchCommunityPortfolioOptions = async ({ signal }) => {
  const measurement = startInsightsMeasure(INSIGHTS_PERFORMANCE.portfolioDirectory)
  try {
    const data = await apiGet('/api/portfolios/all/community-ids', { signal })
    const portfolios = parseCommunityPortfolioIdsResponse(data)
    completeInsightsMeasure(measurement, 'success')
    return portfolios
  } catch (error) {
    completeInsightsMeasure(measurement, 'error')
    if (!signal?.aborted) console.error('Error fetching community portfolios:', error)
    throw error
  }
}

/** Query options for the signed-in user's community portfolio directory. */
export const communityPortfolioOptionsQuery = (userId) => ({
  queryKey: insightsCoreKeys.communityPortfolios(userId),
  queryFn: ({ signal }) => fetchCommunityPortfolioOptions({ signal }),
  enabled: Boolean(userId),
  staleTime: COMMUNITY_PORTFOLIO_STALE_TIME_MS,
})

/**
 * Warm or read the directory outside React (login prefetch). Resolves from
 * cache when fresh, and shares an in-flight request with any mounted reader.
 */
export const loadCommunityPortfolioOptions = (userId, client = queryClient) => {
  if (!userId) return Promise.resolve([])
  return client.fetchQuery(communityPortfolioOptionsQuery(userId))
}
